module.exports = __webpack_public_path__ + "assets/img/d6b5-sh.svg";